import { render } from "./BillPayment.vue?vue&type=template&id=23e1e5a0&scoped=true"
import script from "./BillPayment.vue?vue&type=script&lang=js"
export * from "./BillPayment.vue?vue&type=script&lang=js"

import "./BillPayment.vue?vue&type=style&index=0&id=23e1e5a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e1e5a0"]])

export default __exports__